<script setup lang="ts">
import getMeta from "@/classes/getMeta";
import PageHeader from "~/components/layout/PageHeader.vue";
import PGHS from "@/data/docs/pghs";
import REPORTS from "@/data/docs/reports";
import XDAC from "@/data/docs/xdac";
import XRAD from "@/data/docs/xrad";
import GetMoreLessons from "~/components/GetMoreLessons.vue";
import Sprites from "~/components/icon/Sprites.vue";

const DOC_ITEMS = [ PGHS, REPORTS, XDAC, XRAD ];

definePageMeta({
  layout: "default",
  name: "docs",
});

useHead(getMeta(
    `XSQUARE`,
    `XSQUARE`,
));
</script>

<template>
  <page-header
    h1="Documentation"
    :show-more-button="false"
  />

  <div class="container content-page">
    <docs-list
      :items="DOC_ITEMS"
    />
<!--    <get-more-lessons/>-->

<!--    <div class="additional-doc-links">-->
<!--      <a href="https://edu.rdtex.ru/vendors/khi_kvadrat/?utm=XSQUARE" target="_blank" class="btn fill-violet hover&#45;&#45;scale">-->
<!--        <span>Пройти курсы в официальном авторизованном учебном центре</span>-->
<!--        <icon name="book"/>-->
<!--      </a>-->
<!--    </div>-->
  </div>

  <sprites>
    <symbol id="book" fill="none" stroke="none" viewBox="0 0 32 32">
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-Set-Filled" transform="translate(-310.000000, -1089.000000)" fill="#000000">
          <path fill="currentcolor" d="M332.535,1105.88 L326.879,1111.54 C326.488,1111.93 325.855,1111.93 325.465,1111.54 C325.074,1111.15 325.074,1110.51 325.465,1110.12 L329.586,1106 L319,1106 C318.447,1106 318,1105.55 318,1105 C318,1104.45 318.447,1104 319,1104 L329.586,1104 L325.465,1099.88 C325.074,1099.49 325.074,1098.86 325.465,1098.46 C325.855,1098.07 326.488,1098.07 326.879,1098.46 L332.535,1104.12 C332.775,1104.36 332.85,1104.69 332.795,1105 C332.85,1105.31 332.775,1105.64 332.535,1105.88 L332.535,1105.88 Z M326,1089 C317.163,1089 310,1096.16 310,1105 C310,1113.84 317.163,1121 326,1121 C334.837,1121 342,1113.84 342,1105 C342,1096.16 334.837,1089 326,1089 L326,1089 Z" id="arrow-right-circle" sketch:type="MSShapeGroup">
          </path>
        </g>
      </g>
    </symbol>
  </sprites>
</template>

<style lang="scss" scoped>
.additional-doc-links {
  padding-top: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
  @include onMD {
    padding-top: 30px;
  }
  @include onSM {
    display: block;
    padding-top: 20px;
  }

  @keyframes icon-color-infinity  {
    0% {
      background-position: 0;
    }
    99.99% {
      background-position: 100%;
    }
    100% {
      background-position: 0;
    }
  }

  a {
    line-height: 1.2em;
    @include font-size(20px);
    --min-font-size: 14px;
    color: #fff;
    position: relative;
    background: linear-gradient(25deg, $VIOLET, #f3685b, $VIOLET, #f3685b, $VIOLET, #f3685b, $VIOLET, #f3685b, $VIOLET, #f3685b, $VIOLET, #f3685b, $VIOLET);
    animation: linear infinite icon-color-infinity 8s;
    background-size: 2000% 2000%;
    border: none;
    padding: 20px 35px;
    //border-radius: var(--main-border-radius);
    @include onMD {
      padding: 15px 15px;
    }

    .icon {
      width: 1.5em;
      height: 1.5em;
      vertical-align: middle;
      flex-shrink: 0;
      border-radius: 50%;
    }
  }
}
</style>
